import { render, staticRenderFns } from "./attractForm.vue?vue&type=template&id=dc8b50f2&scoped=true"
import script from "./attractForm.vue?vue&type=script&lang=js"
export * from "./attractForm.vue?vue&type=script&lang=js"
import style0 from "./attractForm.vue?vue&type=style&index=0&id=dc8b50f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8b50f2",
  null
  
)

export default component.exports